import React, { useEffect, useState } from "react";

const BackTop = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      onClick={() =>
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
      data-testid="back-top-button"
      aria-label="Volver al inicio"
      className="fixed z-40 grid place-items-center w-11 h-11 rounded-full text-white transition-all"
      style={{
        right: "27px",
        bottom: "92px",
        background: "rgba(17,18,24,.94)",
        border: "1px solid rgba(217,0,32,.45)",
        boxShadow: "0 10px 30px rgba(0,0,0,.25)",
        opacity: visible ? 1 : 0,
        visibility: visible ? "visible" : "hidden",
        transform: visible ? "translateY(0)" : "translateY(12px)",
      }}
    >
      <svg
        viewBox="0 0 24 24"
        width="20"
        height="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
      >
        <path d="M12 19V5M5 12l7-7 7 7" />
      </svg>
    </button>
  );
};

export default BackTop;
